import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const updateEdges = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    setAtStart(track.scrollLeft <= 4);
    setAtEnd(track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
  }, []);
  useEffect(() => {
    updateEdges();
    const track = trackRef.current;
    if (!track) return;
    track.addEventListener('scroll', updateEdges, {
      passive: true
    });
    window.addEventListener('resize', updateEdges);
    return () => {
      track.removeEventListener('scroll', updateEdges);
      window.removeEventListener('resize', updateEdges);
    };
  }, [updateEdges]);
  const scrollByCard = (direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector('li');
    const step = card ? card.clientWidth + 24 : track.clientWidth * 0.85;
    track.scrollBy({
      left: step * direction,
      behavior: 'smooth'
    });
  };
  return <section className="bg-paper" data-id="element-263" data-mp="c7dh13nio1qs">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-264" data-mp="zwfx472i5mj6">
        <SectionHeading eyebrow="Experiencias" title={<>
              Personas que empezaron a mirar su hogar{' '}
              <span className="text-clay" data-id="element-266" data-mp="14xdguo35uoms">de otra manera</span>
            </>} data-id="element-265" data-mp="zx7rjekd5e7v" />

        <div className="mx-auto mt-12 max-w-5xl sm:mt-16" data-id="element-267" data-mp="q6cwbkp534aa">
          <ul ref={trackRef} className="flex snap-x snap-mandatory items-start gap-6 overflow-x-auto pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-268" data-mp="v4xyvqrv601w">
            {testimonials.map(testimonial => <li key={testimonial.image} className="w-[86%] shrink-0 snap-start overflow-hidden rounded-2xl bg-cream p-3 shadow-card sm:w-[calc((100%-24px)/2)] sm:p-4" data-id="element-269" data-mp="1nma78gvfswzq">
                <img src={testimonial.image} alt={testimonial.alt} className="w-full rounded-xl bg-white object-contain" loading="lazy" data-id="element-270" data-mp="1siwdqiikhw7s" />
              </li>)}
          </ul>

          <div className="mt-8 flex items-center justify-center gap-3" data-id="element-271" data-mp="1ofhpx5oe0bjs">
            <button type="button" onClick={() => scrollByCard(-1)} disabled={atStart} aria-label="Ver testimonios anteriores" className="flex h-12 w-12 items-center justify-center rounded-full border border-sage-line bg-white text-ink shadow-card transition-colors duration-150 ease-out hover:bg-sage-tint disabled:cursor-not-allowed disabled:opacity-35" data-id="element-272" data-mp="1jhg3qbvnzw43">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-273" data-mp="10s02tng2i1n5" />
            </button>
            <button type="button" onClick={() => scrollByCard(1)} disabled={atEnd} aria-label="Ver testimonios siguientes" className="flex h-12 w-12 items-center justify-center rounded-full border border-sage-line bg-white text-ink shadow-card transition-colors duration-150 ease-out hover:bg-sage-tint disabled:cursor-not-allowed disabled:opacity-35" data-id="element-274" data-mp="vsnfz2p74ukk">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-275" data-mp="37epelkinzsii" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}